import { headerLogoEnd } from './HeaderLogoStore.js';

export const updateHeaderLogoEnd = (value) => headerLogoEnd.update((oldValue) => value);
